module.exports = [
  '/_next/',
  '/static/',
  '/health-check',
  '/metrics',
  '/invalidate',
  '/flushall',
  '/opensearch.xml',
]
